import clsx from 'clsx';
import { Panel, type PanelProps } from 'react-resizable-panels';

import styles from './resizable-panel.module.scss';

export const ResizablePanel = (props: ResizablePanelProps) => {
  const { position = 'left', className, children, ...rest } = props;

  return (
    <Panel className={clsx(styles.resizablePanel, styles[`p-${position}`], className)} defaultSize={380} maxSize={600} {...rest}>
      {children}
    </Panel>
  );
};

interface ResizablePanelProps extends PanelProps {
  position?: 'left' | 'right';
}
